module.exports = __webpack_public_path__ + "static/media/frame_42.ca37dd6d.jpg";